(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promotion-banner"] && !Shopify.designMode) return;
  try {
    

  (function () {
    var MOBILE_BREAKPOINT = 767;

    function isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function applyMobileBanner() {
      if (!isMobile()) return;
      var placeholder = document.querySelector('.promo-banner-section .image-placeholder');
      if (!placeholder) return;

      var img = placeholder.querySelector('img[data-mobile-src]');
      if (img && img.dataset.mobileSrc) {
        /* Override the theme-set background with the mobile image */
        placeholder.style.backgroundImage = 'url("' + img.dataset.mobileSrc + '")';
      }
    }

    window.addEventListener('load', function () {
      setTimeout(applyMobileBanner, 300);
    });

    window.addEventListener('resize', function () {
      setTimeout(applyMobileBanner, 100);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    

  (function () {
    var TABLET_BREAKPOINT = 991;

    function isResponsiveScreen() {
      return window.innerWidth <= TABLET_BREAKPOINT;
    }

    function applyMobileImage(slide) {
      if (!isResponsiveScreen()) return;
      var img = slide.querySelector('img[data-mobile-src]');
      if (!img || !img.dataset.mobileSrc) return;

      var mobileUrl = img.dataset.mobileSrc;
      slide.style.backgroundImage = 'url("' + mobileUrl + '")';
      slide.style.backgroundSize = 'cover';
      slide.style.backgroundPosition = 'center center';
      slide.style.backgroundRepeat = 'no-repeat';
    }

    function init() {
      if (!isResponsiveScreen()) return;
      document.querySelectorAll(
        '.primary-slider-section .slide-inner.image-placeholder'
      ).forEach(applyMobileImage);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('resize', function () {
      init();
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-area"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // 1. Resolve CAPTCHA hash action bug by stripping trailing anchors on submit
  const forms = document.querySelectorAll('form');
  forms.forEach(form => {
    form.addEventListener('submit', function() {
      const action = this.getAttribute('action');
      if (action && action.includes('#')) {
        this.setAttribute('action', action.split('#')[0]);
      }
    }, true);
  });

  // 2. Resolve multiple form name conflicts dynamically on interaction/submit
  const newsletterForm = document.getElementById('NewsletterForm');
  const contactForm = document.getElementById('ContactForm');
  
  const newsletterEmail = document.querySelector('#NewsletterForm input[type="email"]');
  const contactEmail = document.querySelector('#ContactForm input[type="email"]');

  function selectNewsletter() {
    if (newsletterEmail) newsletterEmail.setAttribute('name', 'contact[email]');
    if (contactEmail) contactEmail.setAttribute('name', 'contact[email_temp]');
  }

  function selectContact() {
    if (contactEmail) contactEmail.setAttribute('name', 'contact[email]');
    if (newsletterEmail) newsletterEmail.setAttribute('name', 'contact[email_temp]');
  }

  if (newsletterEmail) {
    newsletterEmail.addEventListener('focus', selectNewsletter);
    newsletterEmail.addEventListener('input', selectNewsletter);
  }

  if (contactEmail) {
    contactEmail.addEventListener('focus', selectContact);
    contactEmail.addEventListener('input', selectContact);
  }

  if (newsletterForm) {
    newsletterForm.addEventListener('submit', selectNewsletter, true);
    const btn = newsletterForm.querySelector('[type="submit"]');
    if (btn) btn.addEventListener('click', selectNewsletter, true);
  }

  if (contactForm) {
    contactForm.addEventListener('submit', selectContact, true);
    const btn = contactForm.querySelector('[type="submit"]');
    if (btn) btn.addEventListener('click', selectContact, true);
  }
});

  } catch(e) { console.error(e); }
})();
})();
